import React, { useState } from "react";
import {
  FaHandshake,
  FaShieldAlt,
  FaRocket,
  FaPaperclip,
  FaCheckCircle,
  FaDollarSign,
  FaPaintBrush,
  FaUsers,
  FaStar,
  FaArrowRight,
  FaLinkedin,
  FaInstagram,

} from "react-icons/fa";
import "../css/Partnership.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";
import emailjs from '@emailjs/browser';


const Partnership = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
    message: "",
    portfolio: null,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const partnershipModels = [
    {
      type: "Commission",
      icon: <FaDollarSign />,
      rate: "15-20%",
      description: "Refer clients, earn passive income",
      highlight: "No project management required",
    },
    {
      type: "White Label",
      icon: <FaPaintBrush />,
      rate: "Custom",
      description: "Our services, your brand",
      highlight: "Full white-label solution",
    },
    {
      type: "Project-based",
      icon: <FaUsers />,
      rate: "Flexible",
      description: "Collaborate on specific projects",
      highlight: "Revenue sharing model",
    },
  ];

  const stats = [
    { number: "05+", label: "Active Partners" },
    { number: "10-15%", label: "Commission" },
    { number: "24h", label: "Response" },
    { number: "100%", label: "NDA Safe" },
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const templateParams = {
      name: formData.name,
      email: formData.email,
      company: formData.company || "Not provided",
      message: formData.message,
      portfolio: formData.portfolio ? formData.portfolio.name : "No file attached",
    };

    emailjs
      .send(
        "service_6jx19ac", // ← your EmailJS Service ID
        "template_unsyhjq", // ← your EmailJS Template ID
        templateParams,
        "pf2txmlPhud07pyFT" // ← your EmailJS Public Key
      )
      .then(
        () => {
          setIsSubmitting(false);
          setIsSubmitted(true);
          setFormData({
            name: "",
            email: "",
            company: "",
            message: "",
            portfolio: null,
          });
          setTimeout(() => setIsSubmitted(false), 2500);
        },
        (error) => {
          console.error("EmailJS Error:", error);
          setIsSubmitting(false);
          alert("Failed to send. Please try again later.");
        }
      );
  };

  return (
    <div>
      <Helmet>
        <title>Partner Program | TechSol Technologies</title>
        <meta
          name="description"
          content="Collaborate with TechSol Technologies — Join our Partner Program for commissions, white-label solutions, and project-based opportunities."
        />
      </Helmet>
      <Navbar />

      <div className="modern-partnership">
        {/* Header Section */}
        <header className="compact-header">
          <div className="header-content">
            <div className="partner-badge">Partner Program</div>
            <h1>
              Grow Your Business With <span className="accent-text">TECHSOL</span>
            </h1>
            <p className="header-subtitle">
              Earn commissions • White label • Project collaboration
            </p>

            <div className="mini-stats">
              {stats.map((stat, index) => (
                <div key={index} className="mini-stat">
                  <span className="mini-number">{stat.number}</span>
                  <span className="mini-label">{stat.label}</span>
                </div>
              ))}
            </div>
          </div>
        </header>

        {/* Partnership Models */}
        <section className="models-section">
          <div className="models-container">
            {partnershipModels.map((model, index) => (
              <div key={index} className="model-item">
                <div className="model-icon">{model.icon}</div>
                <div className="model-content">
                  <div className="model-header">
                    <h3>{model.type}</h3>
                    <span className="model-rate">{model.rate}</span>
                  </div>
                  <p className="model-desc">{model.description}</p>
                  <span className="model-highlight">{model.highlight}</span>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Form Section */}
        <section className="integrated-section">
          <div className="content-grid">
            {/* Benefits */}
            <div className="benefits-side">
              <h3>Why Partner With Us?</h3>
              <div className="benefits-list">
                <div className="benefit-item">
                  <FaRocket className="benefit-icon" />
                  <span>Fast project delivery</span>
                </div>
                <div className="benefit-item">
                  <FaShieldAlt className="benefit-icon" />
                  <span>Full NDA protection</span>
                </div>
                <div className="benefit-item">
                  <FaStar className="benefit-icon" />
                  <span>Experienced team</span>
                </div>
                <div className="benefit-item">
                  <FaHandshake className="benefit-icon" />
                  <span>Reliable partnership</span>
                </div>
              </div>

              <div className="quick-links">
                <h4>Quick Connect</h4>
                <div className="link-buttons">
                  <button className="link-btn">
                    <FaLinkedin /> <a className="text-decoration-none text-dark" href="https://www.linkedin.com/company/techsoltech/">LinkedIn</a>
                  </button>
                  <button className="link-btn">
                    <FaInstagram /> <a className="text-decoration-none text-dark" href="https://www.instagram.com/techsol_technologies">Instagram</a>
                  </button>
                </div>
              </div>
            </div>

            {/* Form */}
            <div className="form-side">
              <div className="form-header-compact">
                <h3>Start Partnership</h3>
                <p>Get response within 24 hours</p>
              </div>

              <form className="compact-form" onSubmit={handleSubmit}>
                <div className="form-grid">
                  <div className="form-group-compact">
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      placeholder="Full name"
                      required
                    />
                  </div>

                  <div className="form-group-compact">
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="Email address"
                      required
                    />
                  </div>

                  <div className="form-group-compact full-width">
                    <input
                      type="text"
                      name="company"
                      value={formData.company}
                      onChange={handleInputChange}
                      placeholder="Company or profile link (LinkedIn/Upwork)"
                    />
                  </div>

                  <div className="form-group-compact full-width">
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      placeholder="Tell us about your partnership interest..."
                      rows="3"
                      required
                    />
                  </div>

                  <div className="form-group-compact full-width">
                    <label className="file-label-compact">
                      <FaPaperclip />
                      <span>Attach portfolio (optional)</span>
                      <input
                        type="file"
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            portfolio: e.target.files[0],
                          }))
                        }
                        className="file-input"
                      />
                    </label>
                  </div>
                </div>

                <button
                  type="submit"
                  className={`submit-btn-compact ${
                    isSubmitting ? "submitting" : ""
                  } ${isSubmitted ? "submitted" : ""}`}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>Sending...</>
                  ) : isSubmitted ? (
                    <>
                      <FaCheckCircle /> Sent!
                    </>
                  ) : (
                    <>
                      Become Partner <FaArrowRight />
                    </>
                  )}
                </button>
              </form>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </div>
  );
};

export default Partnership;
